import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { LOCALES, DEFAULT_LOCALE } from "../../shared/locales";
import en from "./locales/en.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";
import it from "./locales/it.json";
import ca from "./locales/ca.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
      fr: { translation: fr },
      pt: { translation: pt },
      it: { translation: it },
      ca: { translation: ca },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: LOCALES as unknown as string[],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "metricspot.lang",
      lookupQuerystring: "lang",
    },
  });

i18n.on("languageChanged", (lng) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lng;
  if (location.hostname.endsWith("metricspot.com")) {
    const secure = location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `ms_lang=${lng}; Domain=.metricspot.com; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
  }
});

export default i18n;
